import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { CalenderIcon } from "@root/assets/icons";
import { SelectedButton, SelectedButtonBox } from "./style";

export const RenderSelectedFields = (props: RenderSelectedFieldsProps) => {
  const { t } = useTranslation("common");
  if (props.type === "chapters") {
    return (
      <SelectedButtonBox>
        {props?.data?.map((chapterId) => {
          const chapter = props?.chapters?.find(
            (c) => c.id.toString() === chapterId
          );
          return chapter ? (
            <SelectedButton key={chapter.id}>
              <Text fontSize="14px">{chapter.name}</Text>
            </SelectedButton>
          ) : null;
        })}
      </SelectedButtonBox>
    );
  }

  if (props.type === "duration") {
    return props.data ? (
      <SelectedButtonBox>
        <SelectedButton>
          <Text fontSize="14px">
            {props.data} {t("setPreference.Month")}
            {props.data !== "1" ? "s" : ""}
          </Text>
        </SelectedButton>
      </SelectedButtonBox>
    ) : null;
  }

  if (props.type === "period") {
    const { start, end } = props.data;
    return start && end ? (
      <SelectedButtonBox>
        <SelectedButton>
          <CalenderIcon color="#FFFFFF" />
          <Text fontSize="14px">
            {start} - {end}
          </Text>
        </SelectedButton>
      </SelectedButtonBox>
    ) : null;
  }

  return null;
};
